import styled from 'styled-components';
import { fontSize, screen } from 'theme';

const Root = styled.div`
  background-color: #fbedff;
  color: #092c61;
  padding: 4rem 0 5rem 0;
  font-size: ${fontSize('lg')};

  .titles {
    flex-direction: column-reverse;
  }
`;

const Wrapper = styled.div`
  background: url('/images/companies-new/companies-new-hero-bg.svg') no-repeat
    top center;
  background-size: cover;
  padding: 3rem 1rem;
  margin-top: 2rem;

  color: #52105e;

  text-align: center;

  p {
    margin: 0;
  }

  h1 {
    font-size: ${fontSize('xl3')} !important;
    font-weight: 800;
    text-wrap: balance;
    margin: 0 0 1.5rem 0;
  }

  @media (min-width: ${screen('xl')}) {
    padding: 180px 0 120px 0;
    background-size: cover;
    text-align: left;

    h1 {
      font-size: ${fontSize('xl5')} !important;
      font-weight: 800;
      margin-top: 3rem;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0;
  max-width: 100%;
  margin: 0 auto;

  img {
    margin: 0 auto;
    max-width: 100%;
  }

  br {
    display: none;
  }

  @media (min-width: ${screen('md')}) {
    margin: 0 auto;
    max-width: 50%;
  }

  @media (min-width: ${screen('xl')}) {
    flex-direction: row;
    gap: 3rem;
    padding: 0 6rem;
    max-width: 100%;
    margin: 0;

    br {
      display: block;
    }

    img {
      max-width: none;
    }
  }
`;

const CTAs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: ${screen('xl')}) {
    flex-direction: row;
  }
`;

export const Hero = {
  Root,
  Wrapper,
  Content,
  CTAs
};
